class CardsLinkSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 'auto',
      scrollbar: {
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true,
        hide: false
      }
    });
  }
}

customElements.define('cards-link-slider', CardsLinkSlider);
